var AbstractViewModel = require("./AbstractViewModel")
var ConsumerInfoWS = require("../ws/ConsumerInfoWS");
var EnterQueueWS = require("../ws/EnterQueueWS");
var MoveConsumerWS = require("../ws/MoveConsumerWS");
var EndServiceTransactionWS = require("../ws/EndServiceTransactionWS");
var UpdateConsumerNameAndNotesWS = require("../ws/UpdateConsumerNameAndNotesWS");
var Phone = require("../lib/phone")

function AddConsumerViewModel(parent) {
  var self = this;

  // Predicate this ViewModel on the Abstract class of a View Model
  // This tacks on additional functionality, including the ability to
  // read URL query parameters, and an observable binding predicated
  // on another object's obcervable-bound variables
  AbstractViewModel.apply(this, arguments);

  self.addToNonActiveQueue = ko.observable(false);
  self.activeQueueId = ko.observable(null);
  self.activeSessionId = ko.observable(null);
  self.callAhead = ko.observable(false);
  self.consumerName = ko.observable(null);
  self.sanitisedConsumerName = ko.pureComputed(
    function () {
      var consumerName = this.consumerName();
      return (consumerName) ? consumerName.trim() : consumerName;
    }, 
    this
  )
  self.consumerFirstName = ko.observable(null);
  self.consumerLastName = ko.observable(null);
  self.customProps = ko.observableArray([]);
  self.firstAvailable = ko.observable(false);
  self.forecastOverride = ko.observable('');
  self.isEnteringConsumer = ko.observable(false);
  self.isMovingConsumer = ko.observable(false);
  self.isReenteringConsumer = ko.observable(false)
  self.notes = ko.observable(null);
  self.originatingQueueId = null;
  self.partySize = ko.observable(null);
  self.phone = ko.observable(null);
  self.queueIds = ko.observableArray([]);
  self.reenterAsExpired = ko.observable(false);
  self.selectedLanguage = ko.observable(null).extend({deferred: true});
  self.selectedTransactionType = ko.observable(null);
  self.suppressText = ko.observable(null);
  self.canAutoPopulateNotes = false;
  self.previousLocale = null;
  self.uuid = ko.observable(null); // We can use this to hide the name field and show the previous receipt number
  self.receiptNumber = ko.observable(null);

  // Only show these Queues
  self.filterQueueIds = ko.observableArray();

  // Service to grab consumer info
  self.consumerInfoWS = new ConsumerInfoWS(self);
  // Inherit the MessageWS from the parent so as to re-use the bundles
  self.messagesWS = self.parent.messagesWS;

  /**
	 * Returns a list of queues, active first, and only queues
   * that are not appointmentsOnly
	 *
	 * @method addQueues
	 * @returns {Array}
	 */
  self.addQueues = ko.computed(function () {
    var filterQueueIds = self.filterQueueIds();

    if (self.isMovingConsumer()) {
      return self.parent.moveableQueues();
    }

    var arr = [];

    arr = self.parent.queues().filter(function (q) {
      return q.state() === 'ACTIVE' && q.appointmentsOnly !== true;
    });

    arr = arr.concat(self.parent.queues().filter(function (q) {
      return q.state() !== 'ACTIVE' && q.appointmentsOnly !== true;
    }));

    if (filterQueueIds.length > 0) {
      console.log("filter queues", filterQueueIds)
      // TODO: [Next Queue Feature] Allow Source Queue? There is a configuration for this?
      arr = arr.filter(function (queue) { 
        return filterQueueIds.indexOf(queue.id) != -1
      })
    }

    return arr;
  });

  self.addConsumerQueueSize = ko.deferredComputed(function () {
    var queues = self.addQueues()
    var size = queues.length + 1
    return (size <= self.ADD_CONSUMER_QUEUE_SIZE_MAX) ? size : self.ADD_CONSUMER_QUEUE_SIZE_MAX
  })

  // Create a subscription to the queue Ids. When these change
  // interrogate the queues belong to and ask them
  // update reenterAsExpiredValue
  self.queueIds.subscribe(function (val) {
    if (val && val.length > 0) {
      var queues = self.queueIds().map(function (queueId) { return self.parent.queuesWS.getQueueById(queueId) });
      var reenterAsExpiredByDefault =  queues.some(function (queue) {
        return queue.reenterAsExpiredCheckbox;
      });
      self.reenterAsExpired(reenterAsExpiredByDefault);
    }

    // Update default forecast when a Queue is selected
    if (val && val.length == 1) {
      self.updateForecastOverride(val[0]);
    }

  }, this);

  self.updateForecastOverride = function(queueId) {
    var queue = self.getQueueById(queueId);
    if (queue && queue.nextWaitDuration) {
      self.forecastOverride(Math.max(queue.nextWaitDuration(), 0));
    }
  }


	/**
	 * Determines the verbiage for the Add Consumer Button
	 *
	 * @method confirmButtonMessage
	 * @returns {String}
	*/
  self.confirmButtonMessage = ko.computed(function () {
        return self.isMovingConsumer() ? self.parent.messagesWS.get('move') :
                                         self.parent.messagesWS.get('add'); 
  })


	/**
	 * Determines if the consumer can be added to the line
	 *
	 * @method addButtonEnabled
	 * @returns {Boolean}
	 */
  self.addButtonEnabled = ko.computed(function () {
    // computed dependencies
    var phone = self.phone();
    var name = self.sanitisedConsumerName();
    var queueIds = self.queueIds();
    var receiptNumber = self.receiptNumber();
    var partySize = self.partySize();
    var customProps = self.customProps();
    var customScreens = self.availableCustomScreens();

    var queues = queueIds
      .map(function (id) { return self.getQueueById(id) })
      .filter(function (value) { return Boolean(value) })

    return this.isAddButtonEnabled(
      { phone, name, receiptNumber },
      queues,
      { partySize, customProps },
      customScreens
    )
  }, this, {deferEvaluation: true });


  /**
   * Forces anything observing the customProps to update
   * 
   * @method customPropsCheck
   * @returns none
   */
  self.customPropsCheck = function () {
    self.customProps.valueHasMutated();
    return true;
  };


	/**
	 * Title with queue name
	 *
	 * @method addCustomerTitle
	 * @returns {String}
	 */
  self.addCustomerTitle = ko.computed(function () {
    if (self.isMovingConsumer()) {
      return self.parent.messagesWS.get('move.customer.to.queue');
    } else if (self.isReenteringConsumer()) {

      if (self.queueIds().length  < 1) {
        return self.parent.messagesWS.get('requeue');
      }

      var titleDisplayName = function () {
        return self.parent.messagesWS.get('customer');
      }

      return self.queueIds().length > 1 ? self.parent.messagesWS.get('nextQueue.multipleQueues')
        .replace('{0}', titleDisplayName())
        :
        self.parent.messagesWS.get('nextQueue.singleQueue')
          .replace('{0}', titleDisplayName())
          .replace('{1}', self.parent.queuesWS.getNameById(self.queueIds()));
    } else {
      return self.parent.messagesWS.get('add.customer.to.queue');
    }
  }, self, { deferEvaluation: true});


	/**
	 * Collects the data about the consumer and sends it to the
   * API handler
	 *
	 * @method addCustomerToQueue
	 * @returns none
	 */
  self.addCustomerToQueue = function () {
    if (self.addButtonEnabled()) {
      if (self.isMovingConsumer()) {
        self.moveConsumerToQueue(self.queueIds()[0]);
      } else {
        self.enterConsumer();
      }
    }
  };

  /**
   * Indicates whether there are Locations that have not loaded Custom Screen data
   */
  self.isLoadingCustomScreens = ko.computed(function () {
    var queueIds = self.queueIds();

    var locations =  queueIds
      .map(function (id) {
        return self.getLocationByQueueId(id)
      })

    // if some screens are not loaded, we are loading
    return locations.some(function (l) {
      return l && !l.customScreens.loaded();
    });
  })


  self.customScreens = ko.computed(function () {
    var queueIds = self.queueIds();

    var value = queueIds
      .map(function (id) {
        return self.getLocationByQueueId(id)
      })
      .reduce(function (customScreens, location) {
        if (location) {
          // N.B. Using `concat` creates a flat list of customScreens
          // that `availableCustomScreens` expects
          // `push` would create an array of arrays
          customScreens = customScreens.concat(location.customScreens());
        }

        return customScreens;
      }, []);

    return value;

  });

  /**
   * Returns a collection of custom screens the user can see
   * 
   * @method availableCustomScreens
   * @returns {Array}
   */
  self.availableCustomScreens = ko.computed(function () {
    var customScreens = self.customScreens();
    var selectedTransactionTypes =
      self.selectedTransactionType() !== null
        ? [self.selectedTransactionType()]
        : [];

    // If multiple queues were selected or, there isn't a selected transaction type,
    // check each queue for an implicit transaction type.
    // If a queue is configured with a single transaction type, it's used implicitly/by default.
    // so we should treat it as selected.

    if (self.queueIds().length > 0 || selectedTransactionTypes.length === 0) {
      var implicitTransactionTypes = self
        .queueIds()
        .reduce(function(transactionTypes, queueId) {
          var queue = self.getQueueById(queueId);
          var hasImplicitTransactionType =
            queue && queue.transactionTypes.length === 1;

          if (hasImplicitTransactionType) {
            transactionTypes.push(queue.transactionTypes[0].id);
          }

          return transactionTypes;
        }, []);

      selectedTransactionTypes = selectedTransactionTypes.concat(implicitTransactionTypes);
    }

    var filteredCustomScreens = customScreens.reduce(function(
      selectedScreens,
      screen
    ) {
      var screenHasFields = screen.fields || screen.fields().length > 0;
      var showCustomScreens = !self.hideCustomScreens();

      if (screenHasFields && showCustomScreens) {
        // the screen is assigned to one of the selected transaction types
        if (selectedTransactionTypes.indexOf(screen.transactionTypeId) > -1) {
          selectedScreens.push(screen);
        }
        // the screen does not have a transaction type
        else if (!screen.transactionTypeId) {
          selectedScreens.push(screen);
        }
      }

      return selectedScreens;
    },
    []);

    // Now walk over each screen, testing it for any duplication of screens
    // that may have been added to the arr collection inside the iterator
    filteredCustomScreens = filteredCustomScreens.reduce(function(
      deduplicatedScreens,
      screen,
      idx
    ) {
      // If it's the first screen, it can't be a duplicate, so just add it
      if (idx === 0) {
        deduplicatedScreens.push(screen);
      } else {
        // Otherwise, check the screen against any others that exist in the deduplicatedScreens
        // collection. If you find a match, don't add the screen
        var foundMatch = false;
        deduplicatedScreens.forEach(function(s) {
          if (self.customScreensIdentical(s, screen)) {
            foundMatch = true;
          }
        });

        if (!foundMatch) {
          deduplicatedScreens.push(screen);
        }
      }

      return deduplicatedScreens;
    },
    []);

    return filteredCustomScreens;
  }, this, {deferEvaluation: true});


  /**
   * Clears the add consumer form and hides it
   *
   * @method cancelAddConsumer
   * @returns none
   */
  self.cancelAddConsumer = function () {
    self.reset();
    self.parent.showAddConsumer(false);
  };


  /**
   * Determines if you are able to edit the consumer 
   * name when moving them
   *
   * @method canEditConsumerName
   * @returns {Boolean}
   */
  self.canEditConsumerName = ko.computed(function () {
    return (
      !this.isMovingOrReentering() ||
      Boolean(this.consumerFirstName()) ||
      (this.phone() && !this.consumerFirstName())
    )
  }, this, { deferEvaluation: true});



  /**
   * Looks up a user by phone and if exists, populates the
   * name field
   * 
   * @method checkForKnownConsumer
   * @returns none
   */
  self.checkForKnownConsumer = function (data, evt) {
    if (self.phoneIsValid()) {
      var phoneWithCC = self.phoneWithCountryCode(self.phone());
      var queue = self.getQueueById(self.originatingQueueId)
      var locationId = (queue) ? queue.locationId : null;

      self.consumerInfoWS.doRequest(function () {
        var infoName = self.consumerInfoWS.consumerName;
        if (infoName && !self.sanitisedConsumerName()) {
          self.consumerName(infoName);
        }

        if (self.canAutoPopulateNotes && !self.notes() && self.consumerInfoWS.notes()) {
          self.notes(self.consumerInfoWS.notes())
        }
      }, locationId, phoneWithCC)
    }
  };


  /**
   * Makes sure that an phone initializing characters (typically
   * 1 or 0) are stripped from the input unless required
   * 
   * @method checkPhoneForInitialChar
   * @param {String} phone
   * @param {Number} defaultPhoneCountryCode
   * @return string
   */
  self.checkPhoneForInitialChar = function (phone, defaultPhoneCountryCode) {
    if (phone.length > 0 && (phone.charAt(0) === '1' || phone.charAt(0) === '0') && defaultPhoneCountryCode === null) {
      return phone.substr(1);
    }

    return phone;
  };


  /**
   * Sets the flag that it is accepted to add a Consumer to a
   * non-active queue
   *
   * @method confirmAddToNonActiveQueue
   * @returns none
   */
  self.confirmAddToNonActiveQueue = function () {
    self.addToNonActiveQueue(true);
  }


  /**
   * Observable to track CustomScreenField input
   * 
   * @method customScreenFieldObservable
   * @param {String} name
   * @param {Mixed} value
   * @returns {ObservableFunction|Null}
   */
  self.customScreenFieldObservable = function (name, value) {
    if (name) {
      name = "customscreenfield_" + name;
      return self.parent.dynamicObservable(name, value);
    }
  };


  /**
   * Returns a collection of custom screens corresponding to 
   * the selected queues of the ViewModel
   * 
   * @method customScreens
   * @returns {Array<CustomScreenModel>}
   */
  self.updateCustomScreens = function () {
    var queueIds = self.queueIds();
    var locations = [];
    var customScreens = [];

    // There must be a queueId in order to find a location in 
    // order to determine custom screens
    if (queueIds.length > 0) {
      // Create a collection of unique location Ids from the queues
      var locIds = queueIds.reduce(function (arr, qId) {
        var q = self.parent.queuesWS.getQueueById(qId);
        if (q && arr.indexOf(q.locationId) === -1) {
          arr.push(q.locationId);
        }
        return arr;
      }, []);

      // If there are location Ids, turn those into LocationModels
      if (locIds.length > 0) {
        locations = locIds.reduce(function (arr, locId) {
          var loc = self.parent.locationsWS.getLocationById(locId);
          if (loc) {
            arr.push(loc);
          }
          return arr;
        }, []);
      }

      // If there are LocationModels, we can inspect for custom screens
      if (locations.length > 0) {
        locations.forEach(function (loc) {
          if (loc.customScreens().length > 0) {
            customScreens = customScreens.concat(loc.customScreens());
          }
        });
      }
    }

    self.customScreens(customScreens);
  };

  /**
   * Provided 2 custom screens, will return true if the fields length
   * match, and each field id is identical to the other screen
   * 
   * @method customScreensIdentical
   * @param {CustomScreenModel} screenA
   * @param {CustomScreenModel} screenB
   * @returns {Boolean}
   */
  self.customScreensIdentical = function (screenA, screenB) {
    var aLen = screenA.fields.length;

    if (aLen === screenB.fields.length) {
      return screenA.fields.filter(function (field, idx) {
        return field.id === screenB.fields[idx].id;
      }).length === aLen;
    }

    return false;
  };


  /**
   * Use a bypass method to abstract the logic from the UI
   * TODO does not seem to be used yet. Needs multi-queue support
   *
   * @method customTicketClassifierFields
   * @returns {Boolean}
   */
  self.customTicketClassifierFields = ko.computed(function () {
    var ids = self.queueIds();

    if (ids.length < 1) {
      return [];
    }

    var l1 = self.getLocationByQueueId(ids[0]);
    var l1CTCF = l1 && l1.customTicketClassifierFields;

    if (ids.length === 1 || !l1CTCF) {
      return l1CTCF || [];
    }

    var allMatch = ids.every(function (qId) {
      return ko.utils.compareArrays(
        l1CTCF, self.getQueueById(qId).customTicketClassifierFields
      );
    });

    return allMatch && l1CTCF || [];
  });

   /**
   * Allows user to Add a consumer after failing previously
   *
   * @method unsetEnterState
   * @returns none
  */
  self.unsetEnterState = function () {
    self.isEnteringConsumer(false);
  }

  /**
   * Enter the consumer into the selected queues
   *
   * @method enterConsumer
   * @returns none
   */
  self.enterConsumer = function () {
    var instrument = {
      transaction: null,
      span: null
    }

    if (typeof window.Sentry != "undefined" && window.Sentry.startTransaction) {
      instrument.transaction = window.Sentry.startTransaction({ name: "qless.cec.action.addconsumer" })
      instrument.span = instrument.transaction.startChild({ op: "qless.cec.ticketing", description: "reserve" })
    }

    self.isEnteringConsumer(true);
    var queues = self.queueIds().map(function (id) { return self.getQueueById(id) });

    // We iterate over each of the queues in the list because we 
    // need a unique enter event to capture the transaction types 
    // for every queue
    queues.forEach(function (q) {
      var enterQueueWS = new EnterQueueWS(self);
      var ttId = null;

      enterQueueWS.addParam('queueId', q.id);

      if (self.showTransactionTypes()) {
        if (queues.length > 1) {
          try {
            ttId = document.getElementById('tt_' + q.id).value;
          }
          catch (e) {
            window.Sentry && window.Sentry.captureException(e);
          }
        }
        else {
          try {
            if (self.singleTTDescription() && self.transactionTypes().length == 1) {
              ttId = null;
            } else {
              ttId = self.selectedTransactionType();
            }
          }
          catch (e) {
            window.Sentry && window.Sentry.captureException(e);
          }
        }

        if (ttId) {
          enterQueueWS.addParam('transactionType', ttId);
        }
      }
      
      if (self.isReenteringConsumer()) {
        enterQueueWS.addParam('startAsExpired', (self.reenterAsExpired()) ? true : false);

        if (self.reenterAsExpired()) {
          enterQueueWS.addParam('priority', '1');
        }

      }

      if (self.phoneIsValid()) {
        enterQueueWS.addParam('phone', self.phoneWithCountryCode(self.phone()));
      }

      if (self.partySize()) {
        enterQueueWS.addParam('partySize', self.partySize());
      }

      if (self.notes()) {
        enterQueueWS.addParam('notes', self.notes());
      }

      if (self.sanitisedConsumerName()) {
        enterQueueWS.addParam('name', self.sanitisedConsumerName());
      }

      self.unbindUnavailableProps();

      var props = self.customProps();
      for (var prop in props) {
        if (props.hasOwnProperty(prop)) {
          var val = props[prop];
          if (val) {
            enterQueueWS.addParam('custom_prop.' + prop, val);
          }
        }
      }

      if (self.suppressText()) {
        enterQueueWS.addParam('communicationMethod', 'VOICE');
      }

      if (self.callAhead()) {
        enterQueueWS.addParam('callAhead', true);
      }

      self.customTicketClassifierFields().forEach(function (f) {
        var el = document.getElementById('ticketClassifier.' + f.name);

        if (el) {
          if (el.tagName.toLowerCase() === 'input' && el.type === 'checkbox' && el.checked === true) {
            enterQueueWS.addParam(el.id, true);
          }
          else if (el.tagName.toLowerCase() === 'select' && el.value !== '' && el.value !== null) {
            enterQueueWS.addParam(el.id, el.value);
          }
        }
      });

      if (self.selectedLanguage()) {
        enterQueueWS.addParam('locale', self.selectedLanguage());
      }
      else if (self.languages().length === 1) {
        enterQueueWS.addParam('locale', self.languages()[0].id);
      }

      var forecastOverride = self.forecastOverride();
      if (forecastOverride !== '' && queues.some(function (q) {
        return forecastOverride !== q.nextWaitDuration() || q.alwaysOverrideForecast;
      })) {
        enterQueueWS.addParam('forecastOverride', forecastOverride);
      }

      var foundConsumer = null;
      var currentQueue = null;

      if (self.isReenteringConsumer()) {
        foundConsumer = self.parent.currentlyServicing().find(function (consumer) {
          return consumer.sessionId == self.activeSessionId()
        });
        currentQueue = self.getQueueById(foundConsumer.queueId);
      }

      if (self.uuid()) {
        enterQueueWS.addParam('uuid', self.uuid())
        if (self.receiptNumber()) {
          enterQueueWS.addParam('receiptNumber', self.receiptNumber())
          if (!self.sanitisedConsumerName()) {
            enterQueueWS.addParam('name', self.receiptNumber())
          }
        }
      }

      enterQueueWS.successHandler = function () {
        if (foundConsumer) {
          if (currentQueue.canApplyServiceResults()) {
            self.cancelAddConsumer();
            self.parent.serviceResultVM.detailShow(foundConsumer);
          } else {
            var endWS = new EndServiceTransactionWS(self.parent);
            endWS.params.transactionId = foundConsumer.transactionId;
            endWS.doRequest(function () {
              self.parent.activeServiceTransactionsWS.doRequest(self.cancelAddConsumer);
            });
          }
        }

        self.cancelAddConsumer();

        if (instrument.span) {
          instrument.span.setStatus("ok")
          instrument.span.finish()
          instrument.transaction.finish()
        }
      };

      // Add the customer to the queue
      enterQueueWS.doRequest();
    });
  }
  
  /**
   * Fill the view model with consumer information from the invoked vm
   *
   * @method fillConsumer
   * @returns none
   */
  self.fillConsumer = function (consumer) {
    // TODO: Duplicates Consumer Real Name vs Ticket Check
    self.consumerName((consumer.name && consumer.firstName) ? consumer.name : '');
    self.consumerFirstName(consumer.firstName);
    self.consumerLastName(consumer.lastName);
    self.phone(consumer.phone);
    self.notes(consumer.notes);
    self.activeQueueId(consumer.queueId);
    self.activeSessionId(consumer.sessionId);
    self.uuid(consumer.uuid);
    self.receiptNumber(consumer.receiptNumber);

    if (consumer.customProps) {
      var tempPropsList = [];
      consumer.customProps.forEach(function (customProp) {
        tempPropsList[customProp.name] = customProp.value
      });
      self.customProps(tempPropsList)
    }
  
    if (consumer.locale) {
      self.selectedLanguage(consumer.locale);

      if (self.isMovingConsumer()) {
        self.previousLocale = consumer.locale;
      }
    }
  }


  /**
   * Prevents non-numeric characters from being entered
   * 
   * @method handlePartySizeKeyDown
   * @returns {Boolean}
   */
  self.handlePartySizeKeyDown = function (data, evt) {
    return (self.parent.isNumericInput(evt) || evt.keyCode === 8 || evt.keyCode === 46);
  };


  /**
   * Prevents non-numeric characters from being entered
   * 
   * @method handlePartySizeKeyUp
   * @returns {Boolean}
   */
  self.handlePartySizeKeyUp = function (data, evt) {
    if (!(self.parent.isNumericInput(evt) || evt.keyCode === 8 || evt.keyCode === 46)) {
      return false;
    }

    var qMax = null;
    var qMin = null;
    self.queueIds().reduce(function (arr, id) {
      arr.push(self.getQueueById(id));
      return arr;
    }, []).forEach(function (q) {
      if (q.maxPartySize) {
        qMax = !qMax ? q.maxPartySize : Math.min(qMax, q.maxPartySize);
      }
      if (q.minPartySize) {
        qMin = !qMin ? q.minPartySize : Math.max(qMin, q.minPartySize);
      }
    });

    if (qMin && Number(self.partySize()) < Number(qMin)) {
      self.partySize(qMin);
    }
    else if (qMax && Number(self.partySize()) > Number(qMax)) {
      self.partySize(qMax);
    }

    return true;
  };

  /**
   * Masks the phone number and looks up known consumers
   * 
   * @method handlePhoneKeyUp
   * @returns none
   */
  self.handlePhoneKeyUp = function (data, evt) {
    self.maskPhone(data, evt);
    self.checkForKnownConsumer(data, evt);
  };

  self.handlePhonePaste = function(data, evt) {
    setTimeout(function() {
      self.maskPhone(data, evt);
      self.checkForKnownConsumer(data, evt);
    });

    return true;
  };


  /**
   * Determines if there are configurations that prevent the custom
   * screens from being presented to the employee
   * 
   * @method hideCustomScreens
   * @returns {Boolean}
   */
  self.hideCustomScreens = function () {
    var hide = false;

    // Merchant-level
    if (self.parseBoolean(self.parent.messagesWS.get('hide.custom.screens'))) {
      hide === true;
    }

    // Location-level
    self.queueIds().forEach(function (qId) {
      var loc = self.getLocationByQueueId(qId);
      var bool = loc && self.parseBoolean(loc.messagesWS.get('hide.custom.screens'));

      if (bool) {
        hide = true;
      }
    });

    return hide;
  };


  /**
   * Returns a list of language objects based on the location locales
   *
   * @method languages
   * @returns {Array}
   */
  self.languages = ko.computed(function () {
    var queueIds = self.queueIds();
    var langs = [];

    queueIds.forEach(function (qId) {
      var loc = self.getLocationByQueueId(qId);
      if (loc && loc.language && loc.language.length > 0) {
        loc.language.forEach(function (lang) {
          var parts = lang.split('_');
          langs.push({
            id: lang,
            lang: self.messagesWS.get('language.' + parts[0])
          });
        });
      }
    });

    return langs;
  });

  this.languages.subscribe(function (languageOptions) {
    var selectedLanguage = self.selectedLanguage()

    if (self.isMovingConsumer() && self.previousLocale && (!selectedLanguage || (self.previousLocale !== selectedLanguage))) {
      var option = languageOptions.find(function (lo) { return lo.id == self.previousLocale })
      if (option) {
        self.selectedLanguage(self.previousLocale);
      }
    }
  }, this)

  this.showLanguageOptions = ko.computed(function () {
    var languages = this.languages();
    return languages.length > 1 
  }, this, { deferEvaluation: true}) 

  /**
   * Reformats the phone input to the specified phone mask
   *
   * @method maskPhone
   * @param {Object} data
   * @param {KeyEvent} evt
   * @returns true
   */
  self.maskPhone = function (data, evt) {
    var el = evt.target;
    var key = evt.keyCode || evt.charCode;
    var del = (key === 8 || key === 46);

    var normalisedNumber = Phone.normaliseTelephoneNumber(el.value)
    var newVal = self.parent.maskPhone(normalisedNumber, del);

    var countryCode = self.defaultCountryCode()
    
    newVal = self.checkPhoneForInitialChar(newVal, countryCode);

    // Set the input's text to the calculated return from this operation
    self.phone(newVal);

    // return true so the operation does not block other events
    return true;
  };

  /**
   * Prepare the viewModel to move a consumer by filling in the current consumer info
   *
   * @method moveConsumer
   * @param {Object} consumer
   * @returns none
   */
  self.moveConsumer = function (consumer) {
    self.isMovingConsumer(true);
    self.fillConsumer(consumer);
  }

  /**
   * Formats the phone number with the default country code
   *
   * @method moveConsumerToQueue
   * @param {Number} queueId
   * @returns none
   */
  self.moveConsumerToQueue = function (queueId) {
    var ws = new MoveConsumerWS(self);

    ws.addParam('source', 'CEC');
    ws.addParam('queueId', self.activeQueueId());
    ws.addParam('sessionId', self.activeSessionId());
    ws.addParam('destinationQueue', self.queueIds()[0]);
    
    if (self.selectedTransactionType()) {
      ws.addParam('transactionType', self.selectedTransactionType());
    }
    
    self.unbindUnavailableProps();

    var props = self.customProps();
    for (var prop in props) {
      if (props.hasOwnProperty(prop)) {
        var val = props[prop];
        if (val) {
          ws.addParam('custom_prop.' + prop, val);
        }
      }
    }

    if (self.suppressText()) {
      ws.addParam('communicationMethod', 'VOICE');
    }

    if (self.callAhead()) {
      ws.addParam('callAhead', true);
    }

    self.customTicketClassifierFields().forEach(function (f) {
      var el = document.getElementById('ticketClassifier.' + f.name);

      if (el) {
        if (el.tagName.toLowerCase() === 'input' && el.type === 'checkbox' && el.checked === true) {
          ws.addParam(el.id, true);
        }
        else if (el.tagName.toLowerCase() === 'select' && el.value !== '' && el.value !== null) {
          ws.addParam(el.id, el.value);
        }
      }
    });

    if (self.selectedLanguage()) {
      ws.addParam('locale', self.selectedLanguage());
    }
    else if (self.languages().length === 1) {
      ws.addParam('locale', self.languages()[0].id);
    }

    var queue = (self.parent.selectedConsumer()) ? self.parent.selectedConsumer().queueId : null
    var sessionId = (self.parent.selectedConsumer()) ? self.parent.selectedConsumer().sessionId : null
    var name = self.sanitisedConsumerName();
    var notes = self.notes();

    if (queue && sessionId) {
      self.updateConsumerNameAndNotes(queue, name, notes, sessionId);
      setTimeout(function () {
        ws.doRequest();
        self.cancelAddConsumer()
      });
    } else {
      self.cancelAddConsumer()
    }
  }

  /**
   * Determines if a valid phone number was entered
   *
   * @method phoneIsValid
   * @returns {Boolean}
   */
  self.phoneIsValid = ko.computed(function () {
    var inputPhoneNumber = self.phone();

    if (!inputPhoneNumber) {
      return false;
    }

    var phoneNumber = self.phoneWithCountryCode(inputPhoneNumber)
    var phoneMask = self.messagesWS.get('phone.mask');

    return (
      (Phone.isValidTelephoneNumber(phoneNumber)) 
      && (phoneMask === '' || inputPhoneNumber.length === phoneMask.length)
    );
  });


  /**
   * Formats the phone number with the default country code
   *
   * @method phoneWithCountryCode
   * @param {String} phone
   * @returns {String}
   */
  self.phoneWithCountryCode = function (phone) {
    var transformedPhone = phone.trim();

    var defaultCountryCode = self.defaultCountryCode()
    if (defaultCountryCode != null) {

      var normalisedPhone = transformedPhone.replace(/[^\d]/g, "")
      if (normalisedPhone.length <= 10) {
        transformedPhone = '+' + defaultCountryCode + transformedPhone;
      }
      else if (transformedPhone.charAt(0) === '0') {
        transformedPhone = '+' + defaultCountryCode + transformedPhone.substring(1)
      }
    }

    return transformedPhone;
  };

  /**
   * Prepare the viewModel to reenter a consumer by filling in the current consumer info
   *
   * @method reenterConsumer
   * @param {Object} consumer
   * @returns none
   */
  self.reenterConsumer = function (consumer) {
    self.fillConsumer(consumer);
    self.isReenteringConsumer(true);
  }

  /**
   * 
   * @param {object} consumer 
   * @param {string[]} nextQueueIds 
   */
  self.reenterConsumerInNextQueues = function(consumer, nextQueueIds) {
    self.fillConsumer(consumer);

    if (nextQueueIds && nextQueueIds.length > 0) {
      // Setup `addQueues` to respond to the upcoming change in `filterQueueIds` once
      self.addQueues.extend({
        subscribeOnce: function (queueOptions) {
          if (queueOptions.length == 1) {
            console.trace("Set Selected Queue", queueOptions[0].id)
            self.setSelectedQueues([queueOptions[0].id])
          }
        }
      })

      self.filterQueueIds(nextQueueIds);
    }
  } 


  /**
   * Resets the add consumer interface to a default state
   *
   * @method reset
   * @returns none
   */
  self.reset = function (iQueueId) {
    self.isMovingConsumer(false);
    self.isEnteringConsumer(false);
    self.isReenteringConsumer(false);

    self.activeQueueId(null);
    self.activeSessionId(null);
    self.uuid(null);
    self.receiptNumber(null);
    self.addToNonActiveQueue(false);
    self.callAhead(false);
    self.consumerName(null);
    self.customProps([]);
    self.firstAvailable(false);
    self.notes(null);
    self.partySize(null);
    self.phone(null);
    self.reenterAsExpired(false);
    self.selectedLanguage(null);
    self.selectedTransactionType(null);
    self.suppressText(null);
    self.previousLocale = null;
    self.consumerFirstName("");
    self.consumerLastName("");

    // Store the originating Queue ID (if not null) so it
    // can be used in the API call to get consumerInfo
    self.originatingQueueId = iQueueId;

    var ids = self.queueIds;
    ids.removeAll();

    // Set the queue ID to the currently selected Queue Id
    if (iQueueId) {
      // First add the initially selected queue to the queues list
      ids.push(iQueueId);
      // Filter out the queues that have defaultAddChoice and appointmentsOnly enabled 
      // and add them to the selected Queues list
      ids.push.apply(ids, self.parent.selectedQueues().filter(function (queue) {
        return queue.defaultAddChoice && !queue.appointmentsOnly && (queue.id !== iQueueId)
      }).map(function (queue) { return queue.id }));

      // Set the forecast
      self.updateForecastOverride(iQueueId)
    }
    else {
      self.forecastOverride('');
    }

    this.filterQueueIds([]);
  };

  /**
   * Updates the selected queues list
   *
   * @method setSelectedQueues
   * @returns none
   */
  self.setSelectedQueues = function (queueIds) {
    self.queueIds(queueIds)
  }

  /**
   * Hook to let us know if we should disable features based on the current state.
   *
   * @method isMovingOrReentering
   * @returns {Boolean}
   */
  self.isMovingOrReentering = ko.computed(function () {
    return self.isMovingConsumer() || self.isReenteringConsumer() ? true : false;
  })

  /**
   * Determines if a UI section needs to be displayed based on the
   * availability of the options in that container. Only shows if
   * all the queues selected all support at least one of these
   *
   * @method showOptions
   * @returns {Boolean}
   */
  self.showOptions = ko.computed(function () {
    var ids = self.queueIds();

    return ids.length > 0 && ids.every(function (qId) {
      var q = self.getQueueById(qId);
      var l = (q && q.locationId) ? self.getLocationById(q.locationId) : null;
      return l && (
        l.supportsFirstAvailable || l.supportsSuppressText || (
          l.customTicketClassifierFields &&
          l.customTicketClassifierFields.length > 0
        ) || (l.language && l.language.length > 1)
      ) || q.supportsCallAhead;
    });
  });


  /**
   * Use a bypass method to abstract the logic from the UI
   * Only shows if all the locations selected all support showPartySize
   *
   * @method showPartySize
   * @returns {Boolean}
   */
  self.showPartySize = ko.computed(function () {
    var ids = self.queueIds();
    return ids.length > 0 && ids.every(function (qId) {
      var l = self.getLocationByQueueId(qId);
      return l && l.usePartySize === true;
    });
  });


  /**
   * Calculates whether, based on the configuration, transaction
   * types should be shown in the add consumer dialogue. Only shows
   * if all the queues selected all support at least one of these
   *
   * @method showTransactionTypes
   * @returns {Boolean}
   */
  self.showTransactionTypes = ko.computed(function () {
    var ids = self.queueIds();
    var suppressTransactions = self.parent.messagesWS.get('suppress.transaction.types.in.add.consumer.dialog') === 'true';
    var forceTransactions = self.parent.messagesWS.get('force.transaction.types.in.add.consumer.dialog') === 'true';

    return ids.length > 0 && ids.filter(function (qId) {
      var q = self.getQueueById(qId);

      return (
        q.transactionTypes.length > 1 && !suppressTransactions
      ) || (q.transactionTypes.length > 0 && forceTransactions);
    }).length > 0;
  });


  /**
   * Determines whether the warning message needs to be presented
   * to the user
   *
   * TODO How to handle multiple queues when one is inactive?
   *
   * @method showWarning
   * @returns {Boolean}
   */
  self.showWarning = ko.computed(function () {
    var ids = self.queueIds();

    if (ids.length < 1 || self.addToNonActiveQueue()) {
      return false;
    }

    if (ids.length === 1) {
      if (self.getQueueById(ids[0]).state().toUpperCase() !== 'ACTIVE') {
        return true;
      }
      return false;
    }

    if (!ids.every(function (qId) {
      return self.getQueueById(qId).state().toUpperCase() === 'ACTIVE';
    })) {
      return true;
    }
    return false;
  });

  /**
   * Use a bypass method to abstract the logic from the UI
   * Only shows if all the queues selected all support call ahead
   *
   * @method supportsCallAhead
   * @returns {Boolean}
   */
  self.supportsCallAhead = ko.computed(function () {
    var ids = self.queueIds();
    return ids.length > 0 && ids.every(function (qId) {
      return self.getQueueById(qId).supportsCallAhead === true;
    });
  });


  /**
   * Use a bypass method to abstract the logic from the UI. Only
   * shows if all the locations selected all support first available
   *
   * @method supportsFirstAvailable
   * @returns {Boolean}
   */
  self.supportsFirstAvailable = ko.computed(function () {
    var ids = self.queueIds();
    return ids.length > 0 && ids.every(function (qId) {
      var l = self.getLocationByQueueId(qId);
      return l && l.supportsFirstAvailable === true;
    });
  });


  /**
   * Use a bypass method to abstract the logic from the UI. Only
   * shows if all the locations selected all support
   * supportsSuppressText
   *
   * @method supportsSuppressText
   * @returns {Boolean}
   */
  self.supportsSuppressText = ko.computed(function () {
    var ids = self.queueIds();
    return ids.length > 0 && ids.every(function (qId) {
      var l = self.getLocationByQueueId(qId);
      return l && l.supportsSuppressText === true;
    });
  });


  /**
   * Returns an array of transaction types from the current queue
   *
   * @method transactionTypes
   * @returns {Array}
   */
  self.transactionTypes = ko.computed(function () {
    var ids = self.queueIds();

    if (ids.length < 1) {
      return [];
    }

    var q1Types = self.getQueueById(ids[0]).transactionTypes;

    if (ids.length === 1) {
      return q1Types || [];
    }

    var allMatch = ids.every(function (qId) {
      return ko.utils.compareArrays(
        q1Types, self.getQueueById(qId).transactionTypes
      );
    });

    return allMatch && q1Types || [];
  });


  /**
   * Returns an array of transaction types for the provided queue Id
   *
   * @method transactionTypesForQueueId
   * @param {Number|String} queueId
   * @returns {Array}
   */
  self.transactionTypesForQueueId = function (queueId) {
    var q = self.getQueueById(Number(queueId));

    if (!q) {
      return [];
    }

    var transactionTypes = q.transactionTypes;

    if (transactionTypes.length > 0) {
      return transactionTypes || [];
    }

    return [];
  };


  /**
   * Returns the description string if there is only one Transaction
   * Type available
   *
   * @method singleTTDescription
   * @returns {String}
   */
  self.singleTTDescription = ko.computed(function () {
    var tTypes = self.transactionTypes();
    return tTypes.length === 1 ? tTypes[0].description : null;
  });

   /**
   * Removed any autopopulated custom prop data that in not relvent to the current queue
   *
   * @method unbindUnavailableProps
   * @returns none
   */
  self.unbindUnavailableProps = function () {
    var tempPropsList = [];

    var availableFields = self
      .availableCustomScreens()
      .reduce(function (fieldNames, screen) {
        var fields = screen.fields.map(function (field) {
          return field.name
        });

        return fieldNames.concat(fields);
      }, [])
      .toString().split(',');

    for (var key in self.customProps()) {
        if (availableFields.indexOf(key) > -1 ) {
          tempPropsList[key] = self.customProps()[key]
        }
    }
    self.customProps(tempPropsList)
  }


  /**
   * Updates consumer name and notes 
   * before a user has been moved to a different queue 
   *
   * @method updateConsumerNameAndNotes
   * @returns none
   */
  self.updateConsumerNameAndNotes = function (queueId, name, notes, sessionId) {
    var ws = new UpdateConsumerNameAndNotesWS(queueId);

    ws.addParam('sessionId', sessionId);

    if (name) {
      ws.addParam('name', name);
    }
    if (notes) {
      ws.addParam('notes', notes);
    }

    ws.doRequest();
  }


  /**
   * Returns the format message for the queue if any selected queue
   * is not in an ACTIVE state
   *
   * @method warningMessage
   * @returns {String}
   */
  self.warningMessage = ko.computed(function () {
    var msg = '';
    var msg2 = '';
    var inactiveState = false;
    var closedState = false;

    self.queueIds().some(function (qId) {
      var state = self.getQueueById(qId).state().toUpperCase();
      if (state === 'INACTIVE') {
        inactiveState = true;
        return true;
      }
      if (['CLOSED', 'CLOSING'].indexOf(state) > -1) {
        closedState = true;
        return true;
      }
    });

    if (inactiveState) {
      msg = self.parent.messagesWS.get('confirm.add.inactive.1');
      msg2 = self.parent.messagesWS.get('confirm.add.inactive.2');
      msg = msg + (msg2 ? '<br>' + msg2 : '');
    }

    if (closedState) {
      msg = self.parent.messagesWS.get('confirm.add.closed.1');
      msg2 = self.parent.messagesWS.get('confirm.add.closed.2');
      msg = msg + (msg2 ? '<br>' + msg2 : '');
    }

    return msg;
  });


  this.handleLanguagesChange = function () {
    // When an Employee explicitly changes the Language while moving a Consumer, do not automatically use the Consumer's language
    // if different queues are selected after.
    if (this.isMovingConsumer() && this.previousLocale && this.selectedLanguage() !== this.previousLocale) {
      this.previousLocale = null;
    }
  }

  this.isNameRequired = ko.computed(function () {
    var receiptNumber = this.receiptNumber()
    var phoneNumber = this.phone()
    var firstName = this.consumerFirstName()
    var name = this.sanitisedConsumerName()
    return !name && this._isNameRequired(phoneNumber, receiptNumber, firstName)
  }, this, { deferEvaluation: true })

  this.isPhoneNumberRequired = ko.computed(function () {
    var receiptNumber = this.receiptNumber()
    var name = this.sanitisedConsumerName()
    var phone = this.phone()
    var isValidPhoneNumber = this.isPhoneValid(phone)
    return !isValidPhoneNumber && this._isPhoneNumberRequired(name, receiptNumber)
  }, this, { deferEvaluation: true })

  this.isQueueRequired = ko.computed(function () {
    var selectedQueueIds = this.queueIds()
    return  (!selectedQueueIds || selectedQueueIds.length < 1)
  }, this, { deferEvaluation: true })

  /**
   * Ticket Number is only shown when Moving a Consumer that only has a Ticket Number and
   * does not have an actual Name
   */
  this.showTicketNumber = ko.pureComputed(function () {
    var name = this.sanitisedConsumerName()
    var receiptNumber = this.receiptNumber()
    var firstName = this.consumerFirstName()
    var isMovingOrReentering = this.isMovingOrReentering()
    // TODO: Refactor - Duplicates the logic in SpotModel.canShowTicketNumber
    return (isMovingOrReentering &&
      (receiptNumber !== null && typeof receiptNumber !== "undefined") &&
      (!firstName || (name !== receiptNumber))
    )
  }, this)

  this.showPhoneNumber = ko.pureComputed(function () {
    return (!this.isMovingOrReentering() || this.phone())
  }, this)

  this.showName = ko.pureComputed(function () {
    return (
      !this.isMovingOrReentering() ||
      (this.consumerFirstName() || this.phone())
    )
  }, this)

  

  // Expose the object as it's own API
  return self;
}

AddConsumerViewModel.prototype = AbstractViewModel.prototype;
AddConsumerViewModel.prototype.constructor = AddConsumerViewModel;

AddConsumerViewModel.prototype.enableAutoPopulateNotes = function enableAutoPopulateNotes() {
  this.canAutoPopulateNotes = true;
}

AddConsumerViewModel.prototype.disableAutoPopulateNotes = function enableAutoPopulateNotes() {
  this.canAutoPopulateNotes = false;
}

AddConsumerViewModel.prototype.defaultCountryCode = function () {
  return this.queueIds().reduce(function (lastCountryCode, id) {
    var queue = this.parent.queuesWS.getQueueById(id);
    var defaultPhoneCountryCode = queue.defaultPhoneCountryCode()

    return (defaultPhoneCountryCode) ? defaultPhoneCountryCode : lastCountryCode
  }.bind(this), null);
} 


/**
 * @param {number} id the queue id
 * @returns {QueueModel}
 */
AddConsumerViewModel.prototype.getQueueById = function (id) {
  return (id) ? this.parent.queuesWS.getQueueById(id) : null;
}

/**
 * @param {number} id the location id
 * @returns {LocationModel}
 */
AddConsumerViewModel.prototype.getLocationById = function (id) {
  return (id) ? this.parent.locationsWS.getLocationById(id) : null;
}

/**
 * 
 * @param {number} id queue id
 * @returns {LocationModel}
 */
AddConsumerViewModel.prototype.getLocationByQueueId = function (id) {
  if (id) {
    var queue = this.getQueueById(id)
    return (queue) ? this.getLocationById(queue.locationId) : null;
  }

  return null;
}

AddConsumerViewModel.prototype.ADD_CONSUMER_QUEUE_SIZE_MAX = 7;

AddConsumerViewModel.prototype.partySizeLargeEnoughToJoin = function (queue, requestedPartySize) {
  var isValid = true;

  if (queue.minPartySize) {
    isValid = Number(requestedPartySize) >= queue.minPartySize;
  }

  if (!queue.ticketBasedOnPartySize && (requestedPartySize === null || requestedPartySize === '')) {
    isValid = true;
  }

  return isValid;
}

/**
 * 
 * @param {{phone?:string, name?:string, receiptNumber?:string}} consumer
 * @param {QueueModel[]} queues
 * @param {{partySize:string, customProps: {[field]:string}}, language: string } options
 * @param {CustomScreenModel[]} customScreens
 */
AddConsumerViewModel.prototype.isAddButtonEnabled = function(
  consumer,
  queues,
  options,
  customScreens
) {
  var phone = consumer.phone;
  var name = consumer.name;
  var receiptNumber = consumer.receiptNumber;
  var partySize = options.partySize;
  var customProps = options.customProps;

  var hasSelectedQueues = (queues.length > 0);

  var isPartySizeValid = (hasSelectedQueues)
    ? queues.every(function (queue) {
        return this.partySizeLargeEnoughToJoin(queue, partySize)
      }.bind(this))
    : false;

  var hasAValidConsumerIdentifier = (AddConsumerViewModel.hasName(name) || AddConsumerViewModel.hasReceiptNumber(receiptNumber) || this.isPhoneValid(phone))

  var isEnabled = hasSelectedQueues &&
    isPartySizeValid &&
    hasAValidConsumerIdentifier &&
    AddConsumerViewModel.validateCustomProperties(customProps, customScreens)

  return isEnabled;
}

AddConsumerViewModel.validateCustomProperties = function(customProperties, customScreens) {
    var hasValue = function (value) {
      if (typeof value === "string") {
        value = value.trim();
      }

      return value && value !== ''
    }

    var areFieldsValid = customScreens
      .reduce(function (validationResults, customScreen) {
        return validationResults
          .concat(customScreen.fields
            .filter(function (field) { return field.required })
            .map(function (field) { return hasValue(customProperties[field.name]) })
          )
      }, [])
      .every(function (v) { return v })

    return areFieldsValid;
}

AddConsumerViewModel.hasReceiptNumber = function (receiptNumber) {
  return Boolean(receiptNumber);
}

AddConsumerViewModel.hasName = function (name) {
  return Boolean(name);
}

AddConsumerViewModel.prototype.isPhoneValid = function (inputPhoneNumber) {
  var hasPhone = Boolean(inputPhoneNumber)
  if (!hasPhone) {
    return false;
  }

  var hasCorrectFormat = this.checkPhoneMask(inputPhoneNumber, this.messagesWS);

  var phoneNumberWithCountryCode = this.phoneWithCountryCode(inputPhoneNumber)
  var isValidPhoneNumber = Phone.isValidTelephoneNumber(phoneNumberWithCountryCode)

  return (isValidPhoneNumber && hasCorrectFormat)
}

AddConsumerViewModel.prototype.checkPhoneMask = function (inputPhoneNumber, messagesWS) {
  var hasPhone = Boolean(inputPhoneNumber)
  if (!hasPhone) {
    return false;
  }

  var phoneMask = messagesWS.get("phone.mask");
  return (phoneMask === '' || inputPhoneNumber.length === phoneMask.length)
}

AddConsumerViewModel.prototype._isNameRequired = function(phoneNumber, receiptNumber, firstName) {
  return (!phoneNumber && (!receiptNumber || !firstName))
}

AddConsumerViewModel.prototype._isPhoneNumberRequired = function(name, receiptNumber) {
  return (!name && !receiptNumber)
}

module.exports = AddConsumerViewModel
